module.exports = __webpack_public_path__ + "static/rewards-card-banner-marcus-573460efc8ed6675ab9e8706a3cd57dd.png";